import React, { useState, useEffect, useRef, ReactNode } from 'react';

import ProgressBar from 'components/ProgressBar';

import { Container, Content, IconContainer, Box, Icon, HeaderFixedSpace, RightButton } from './styles';

export interface Props {
  children?: ReactNode | (JSX.Element | boolean)[] | JSX.Element | string;
  rightIcon?: string;
  rightLabel?: string;
  rightAction?: () => void;
  loading?: boolean;
  goBack?: () => void;
  noGoBack?: boolean;
  className?: string;
  noShadow?: boolean;
}

type RightActionProps = {
  action?: () => void;
  icon?: string;
  label?: string;
};

const RightAction = ({ action, icon, label }: RightActionProps) => {
  if (!icon && !label) return <IconContainer />;

  if (icon)
    return (
      <IconContainer>
        <Icon src={icon} onClick={action} alt="" />
      </IconContainer>
    );

  return <RightButton onClick={action}>{label}</RightButton>;
};

const AppBar = ({
  children,
  goBack,
  rightIcon,
  rightLabel,
  rightAction,
  loading,
  className,
  noGoBack,
  noShadow,
}: Props) => {
  const progressLimit = 10;
  const loadingProgressTimer = useRef<number>();
  const [loadingProgress, setLoadingProgress] = useState(1);

  const addProgress = () => {
    setLoadingProgress((currentProgress) => {
      if (currentProgress < progressLimit - 1) {
        return currentProgress + 1;
      }
      return currentProgress;
    });
  };

  useEffect(() => {
    if (loading) {
      loadingProgressTimer.current = window.setInterval(addProgress, 200);
    } else {
      clearInterval(loadingProgressTimer.current);
      setLoadingProgress(1);
    }
    return () => clearInterval(loadingProgressTimer.current);
  }, [loading]);

  return (
    <>
      <HeaderFixedSpace $isFixedHeader />
      <Container className={className || ''} $isFixedHeader $noShadow={noShadow}>
        <Content>
          <IconContainer>
            {!noGoBack && <Icon onClick={goBack} src="/images/back-arrow.svg" alt="back-arrow" />}
          </IconContainer>
          <Box className="box">{children}</Box>
          <RightAction action={rightAction} label={rightLabel} icon={rightIcon} />
        </Content>
        {loading && <ProgressBar steps={progressLimit} actualStep={loadingProgress} />}
      </Container>
    </>
  );
};

export default AppBar;
